import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Paginacao } from '../../comum/modelos/paginacao';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ConfigOcorrenciaAuto } from '../../comum/modelos/config-ocorrencia-auto';
import { CriterioAvaliacaoRotinaCliente } from '../../comum/modelos/criterio-avaliacao-rotina-cliente';
import { RotinaCliente } from '../../comum/modelos/rotina-cliente';
import { RotinaService } from '../../rotina/rotina.service';
import { OcorrenciasService } from '../ocorrencias.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { SelectItem } from 'primeng/primeng';
import { Usuario } from '../../comum/modelos/usuario';
import { UsuarioService } from '../../usuario/usuario.service';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-cadastro-agendamento-ocorrencia',
  templateUrl: './cadastro-agendamento-ocorrencia.component.html',
  styleUrls: ['./cadastro-agendamento-ocorrencia.component.css']
})
export class CadastroAgendamentoOcorrenciaComponent implements OnInit {

  rotinasCliente: RotinaCliente[];
  rotinasSelectItem: SelectItem[];
  usuariosResponsaveis: Usuario[];
  usuariosResponsaveisSelectItem: SelectItem[];
  usuariosPrimeiraAlcadaSelectItem: SelectItem[];
  usuariosSegundaAlcadaSelectItem: SelectItem[];
  usuariosTerceiraAlcadaSelectItem: SelectItem[];
  criteriosAvaliacaoRotina: CriterioAvaliacaoRotinaCliente[];
  configOcorrenciaAuto: ConfigOcorrenciaAuto;
  pt: any;
  dateFormat = 'dd/mm/yy';

  MODO: string;
  CADASTRAR = 'Cadastrar';
  ATUALIZAR = 'Atualizar';
  statusCode: number;
  selecionados: boolean;

  public evento: Evento;
  public paginacao: Paginacao;

  public loading = false;

  constructor(
    private _comumService: ComumService,
    private _rotinaService: RotinaService,
    private _ocorrenciaService: OcorrenciasService,
    private _usuarioService: UsuarioService,
    private _activatedRoute: ActivatedRoute,
    private router: Router,
    private _cookieService: CookieService,
    public _authService: AuthService) {
    this.rotinasCliente = new Array<RotinaCliente>();
    this.rotinasSelectItem = new Array<SelectItem>();
    this.usuariosResponsaveis = new Array<Usuario>();
    this.usuariosResponsaveisSelectItem = new Array<SelectItem>();
    this.usuariosPrimeiraAlcadaSelectItem = new Array<SelectItem>();
    this.usuariosSegundaAlcadaSelectItem = new Array<SelectItem>();
    this.usuariosTerceiraAlcadaSelectItem = new Array<SelectItem>();
    this.criteriosAvaliacaoRotina = new Array<CriterioAvaliacaoRotinaCliente>();
    this.configOcorrenciaAuto = new ConfigOcorrenciaAuto();
    this.evento = this._comumService.evento;
    this.paginacao = new Paginacao();
  }

  ngOnInit() {
    this.paginacao.itens = 5;
    this.paginacao.page = 1;
    this.loading = true;
    this.pt = {
      firstDayOfWeek: 1,
      dayNames: ['domingo', 'segunda', 'ter\xE7a', 'quarta', 'quinta', 'sexta', 's\xE1bado'],
      dayNamesShort: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 's\xE1b'],
      dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
      monthNames: ['janeiro', 'fevereiro', 'mar\xE7o', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro',
        'outubro', 'novembro', 'dezembro'],
      monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
      today: 'Hoje',
      clear: 'Apagar'
    };
    const id = this._activatedRoute.snapshot.params['id'];
    const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
    const self = this;

    if (id !== undefined) {
      forkJoin(
        this._ocorrenciaService.obterAgendamentoOcorrenciaAutoHttp(id),
        this._rotinaService.obterRotinasClienteObrigacaoFotoHttp(idCliente),
        this._usuarioService.obterUsuariosHttp(idCliente))
        .subscribe(([configOcorrencia, rotinasCliente, usuarios]) => {
          self.usuariosResponsaveis = usuarios;
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosResponsaveisSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosPrimeiraAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosSegundaAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosTerceiraAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.rotinasCliente = rotinasCliente;
          self.rotinasCliente.forEach(rotina => {
            self.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
          });
          self.configOcorrenciaAuto = configOcorrencia;
          if (self.configOcorrenciaAuto.dataAteReincidencia !== null) {
            self.configOcorrenciaAuto.dataAteReincidencia = new Date(configOcorrencia.dataAteReincidencia);
          }
          self._rotinaService.obterCriterioAvaliacaoRotinaClienteObrigacaoFotoHttp(
            configOcorrencia.rotinaCliente.idRotinaCliente)
            .subscribe((criterios) => {
              self.criteriosAvaliacaoRotina = criterios;
            });
          self.loading = false;
          this.MODO = this.ATUALIZAR;
        });
    } else {
      forkJoin(this._rotinaService.obterRotinasClienteObrigacaoFotoHttp(idCliente),
        this._usuarioService.obterUsuariosHttp(idCliente))
        .subscribe(([rotinasCliente, usuarios]) => {
          self.rotinasCliente = rotinasCliente;
          self.usuariosResponsaveis = usuarios;
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosResponsaveisSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosPrimeiraAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosSegundaAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.usuariosResponsaveis.forEach(usuario => {
            self.usuariosTerceiraAlcadaSelectItem.push({ label: usuario.nomeUsuario + ' / ' + usuario.email, value: usuario.idUsuario });
          });
          self.rotinasCliente.forEach(rotina => {
            self.rotinasSelectItem.push({ label: rotina.descricaoRotina, value: rotina.idRotinaCliente });
          });
          self.loading = false;
          this.MODO = this.CADASTRAR;
        });
    }
  }

  selecionarCriterios(idRotinaCliente: number) {
    this._rotinaService.obterCriterioAvaliacaoRotinaClienteObrigacaoFotoHttp(idRotinaCliente)
      .subscribe((criterios) => {
        this.criteriosAvaliacaoRotina = criterios;
      });
  }

  onSubmit(): void {
    this.loading = true;
    const self = this;

    if (this.MODO === this.CADASTRAR) {
      this.configOcorrenciaAuto.idCliente = parseInt(this._cookieService.get('idCliente'), 10);
      this._ocorrenciaService.cadastrarConfigOcorrenciaAutoHttp(this.configOcorrenciaAuto)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.cadastro = true;
          self.router.navigate(['listar-agendamento-ocorrencias']);
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    } else {
      this._ocorrenciaService.atualizarConfigOcorrenciaAutoHttp(this.configOcorrenciaAuto)
        .subscribe(response => {
          self.loading = false;
          self.statusCode = response.status;
          self._comumService.evento.atualizar = true;
          self.router.navigate(['listar-agendamento-ocorrencias']);
          console.log(response);
        }, errorCode => {
          self.statusCode = errorCode;
          self.loading = false;
        });
    }
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/cadastro-agendamento-ocorrencia/cadastro-agendamento-ocorrencia.component.ts